import { render } from "./userloginlog.vue?vue&type=template&id=87576352&scoped=true&ts=true"
import script from "./userloginlog.vue?vue&type=script&lang=ts"
export * from "./userloginlog.vue?vue&type=script&lang=ts"

import "./userloginlog.vue?vue&type=style&index=0&id=87576352&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87576352"]])

export default __exports__